module.exports = __webpack_public_path__ + "img/lac-logo-white.07ba13f5.svg";